var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArlLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235.71,
    height: 70.64,
    viewBox: "0 0 235.71 70.64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 100.43 35.31)",
    id: "Gb-EwCnTtKr-Wpc6mefPT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,213,50)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-122.57, -54.74)",
    d: "M 111.254 68.132 C 110.292 68.132 109.712 67.35300000000001 109.97800000000001 66.37400000000001 L 116.21100000000001 43.09700000000001 C 116.47700000000002 42.135000000000005 117.47200000000001 41.34000000000001 118.43400000000001 41.34000000000001 L 140.12 41.34000000000001 L 140.75 39.00200000000001 C 141.099 37.70900000000001 140.336 36.665000000000006 139.043 36.665000000000006 L 116.42800000000001 36.665000000000006 C 114.68800000000002 36.665000000000006 112.897 38.074000000000005 112.433 39.815000000000005 L 104.424 69.659 C 103.96000000000001 71.4 104.988 72.80900000000001 106.72900000000001 72.80900000000001 L 129.34400000000002 72.80900000000001 C 130.63700000000003 72.80900000000001 131.96400000000003 71.76400000000001 132.312 70.47100000000002 L 132.942 68.13300000000002 L 111.254 68.13300000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 100.34 35.32)",
    id: "Qff38A34MovpOgrnLSh46"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-122.48, -54.74)",
    d: "M 150.067 27.345 L 109.57900000000001 27.345 C 107.83900000000001 27.345 106.048 28.755 105.584 30.494999999999997 L 92.586 78.992 C 92.121 80.732 93.149 82.141 94.89 82.141 L 135.378 82.141 C 137.119 82.141 138.909 80.732 139.373 78.992 L 141.446 71.28200000000001 C 141.91 69.54100000000001 140.883 68.132 139.141 68.132 L 137.61599999999999 68.132 L 135.577 75.726 C 135.311 76.688 134.316 77.484 133.35399999999998 77.484 L 99.416 77.484 C 98.454 77.484 97.874 76.705 98.14 75.726 L 109.38 33.762 C 109.646 32.801 110.64099999999999 32.005 111.603 32.005 L 145.541 32.005 C 146.503 32.005 147.083 32.784000000000006 146.81799999999998 33.762 L 144.778 41.356 L 146.303 41.356 C 148.044 41.356 149.835 39.946000000000005 150.299 38.206 L 152.371 30.497000000000003 C 152.837 28.755 151.809 27.345 150.067 27.345",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 221.05 35.32)",
    id: "RbHxGEH_CHMUSevz_ZRCG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-243.19, -54.74)",
    d: "M 252.681 63.456 L 248.00500000000002 63.456 L 250.34300000000002 54.735 L 242.717 63.456 L 238.985 63.456 L 236.019 54.735 L 233.697 63.456 L 229.02100000000002 63.456 L 233.697 46.031000000000006 L 238.373 46.031000000000006 L 242.285 57.86900000000001 L 252.68099999999998 46.031000000000006 L 257.356 46.031000000000006 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 195.23 35.32)",
    id: "5kINjoFvoVx2-wcvgwDSw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-217.37, -54.74)",
    d: "M 221.229 63.456 L 208.84400000000002 63.456 C 207.103 63.456 206.074 62.047000000000004 206.53900000000002 60.307 L 209.52300000000002 49.182 C 209.98700000000002 47.441 211.77800000000002 46.032000000000004 213.51800000000003 46.032000000000004 L 225.90400000000002 46.032000000000004 C 227.64500000000004 46.032000000000004 228.67400000000004 47.442 228.20900000000003 49.182 L 225.22500000000002 60.307 C 224.761 62.047 222.97 63.456 221.229 63.456 M 221.112 58.25 L 222.986 51.237 C 223.25199999999998 50.275 222.672 49.479 221.709 49.479 L 215.873 49.479 C 214.91199999999998 49.479 213.917 50.258 213.652 51.237 L 211.778 58.25 C 211.512 59.212 212.09199999999998 60.008 213.054 60.008 L 218.89000000000001 60.008 C 219.854 59.991 220.848 59.212 221.112 58.25",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 173.86 35.31)",
    id: "sMtGnMMofkGykDqkPiV01"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-196, -54.73)",
    d: "M 201.863 63.456 L 187.87 63.456 C 186.145 63.456 185.11700000000002 62.047000000000004 185.582 60.323 L 188.566 49.147999999999996 C 189.03 47.424 190.804 46.013999999999996 192.54500000000002 46.013999999999996 L 206.538 46.013999999999996 L 206.073 47.721999999999994 C 205.80800000000002 48.684 204.81300000000002 49.48 203.852 49.48 L 194.898 49.48 C 193.93699999999998 49.48 192.942 50.259 192.677 51.236999999999995 L 190.803 58.24999999999999 C 190.537 59.211999999999996 191.118 60.007999999999996 192.079 60.007999999999996 L 201.03300000000002 60.007999999999996 C 201.99400000000003 60.007999999999996 202.574 60.787 202.30900000000003 61.76499999999999 L 201.863 63.456 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 152.95 35.33)",
    id: "4D3vUxEsQfbHoNXP_bYF0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-175.09, -54.75)",
    d: "M 186.775 46.031 L 173.37900000000002 63.474000000000004 L 167.46 63.474000000000004 L 163.41400000000002 46.031000000000006 L 167.65900000000002 46.031000000000006 C 168.32200000000003 46.031000000000006 168.836 46.413000000000004 168.96900000000002 47.010000000000005 L 171.68800000000002 58.831 L 180.72400000000002 47.010000000000005 C 181.17200000000003 46.413000000000004 181.88500000000002 46.031000000000006 182.54800000000003 46.031000000000006 L 186.775 46.031000000000006 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 104.61 35.31)",
    id: "qtTaDtMSYqDve3csKjCh-"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-126.75, -54.73)",
    d: "M 130.968 63.456 L 115.43299999999999 63.456 L 120.10799999999999 46.014 L 135.64399999999998 46.014 C 137.384 46.014 138.41299999999998 47.423 137.94799999999998 49.164 L 134.96499999999997 60.29 C 134.482 62.047 132.709 63.456 130.968 63.456 M 130.835 58.25 L 132.709 51.237 C 132.974 50.275 132.394 49.479 131.43200000000002 49.479 L 123.83800000000002 49.479 L 121.02000000000002 59.991 L 128.61400000000003 59.991 C 129.591 59.991 130.586 59.212 130.835 58.25",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 127.98 35.3)",
    id: "MXhpNYQI5gAa16dnL4eo7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-150.12, -54.73)",
    d: "M 155.97 63.456 L 142.01 63.456 C 140.26899999999998 63.456 139.24099999999999 62.047000000000004 139.70499999999998 60.307 L 142.689 49.148 C 143.154 47.407000000000004 144.944 45.998000000000005 146.668 45.998000000000005 L 160.62800000000001 45.998000000000005 C 160.645 45.998000000000005 160.645 46.014 160.645 46.031000000000006 L 160.198 47.72200000000001 C 159.93200000000002 48.68400000000001 158.955 49.46300000000001 157.993 49.46300000000001 L 147.299 49.46300000000001 C 147.282 49.46300000000001 147.26600000000002 49.48000000000001 147.26600000000002 49.49600000000001 L 146.603 51.96700000000001 C 146.603 51.984000000000016 146.603 52.000000000000014 146.62 52.000000000000014 L 159.022 52.000000000000014 C 159.03799999999998 52.000000000000014 159.03799999999998 52.01700000000002 159.03799999999998 52.033000000000015 L 158.59099999999998 53.72400000000002 C 158.325 54.68500000000002 157.34699999999998 55.46400000000002 156.38599999999997 55.46400000000002 L 145.69 55.46400000000002 C 145.673 55.46400000000002 145.657 55.48100000000002 145.657 55.49700000000002 L 144.447 60.00700000000002 L 155.157 60.00700000000002 C 156.119 60.00700000000002 156.68300000000002 60.78600000000002 156.434 61.74800000000002 L 155.986 63.43800000000002 C 155.986 63.456 155.986 63.456 155.97 63.456",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 125.9 51.6)",
    id: "n_tJ6872AlDLN84DSJ1XT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-148.04, -71.02)",
    d: "M 148.99 68.115 L 150.20000000000002 68.115 L 151.211 73.934 L 149.836 73.934 L 149.637 72.64099999999999 L 147.1 72.64099999999999 L 146.204 73.934 L 144.86100000000002 73.934 L 148.99 68.115 z M 149.471 71.515 L 149.173 69.641 L 147.879 71.515 L 149.471 71.515 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 132.61 51.61)",
    id: "pUvM-EGh390E0Hl3KEIPT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-154.75, -71.04)",
    d: "M 153.218 68.148 L 155.95399999999998 68.148 C 156.71599999999998 68.148 157.24699999999999 68.347 157.545 68.728 C 157.79399999999998 69.05999999999999 157.85999999999999 69.49199999999999 157.71099999999998 70.05499999999999 L 157.71099999999998 70.07199999999999 C 157.57799999999997 70.53599999999999 157.36299999999997 70.91799999999999 157.04799999999997 71.216 C 156.73299999999998 71.515 156.36699999999996 71.72999999999999 155.95399999999998 71.862 L 156.86499999999998 73.934 L 155.32299999999998 73.934 L 154.54399999999998 72.078 L 154.527 72.078 L 153.516 72.078 L 153.01899999999998 73.934 L 151.70799999999997 73.934 L 153.218 68.148 z M 155.108 70.967 C 155.439 70.967 155.705 70.902 155.92000000000002 70.736 C 156.13600000000002 70.587 156.269 70.387 156.335 70.13900000000001 L 156.335 70.12100000000001 C 156.401 69.84 156.36700000000002 69.641 156.235 69.492 C 156.086 69.358 155.854 69.293 155.52100000000002 69.293 L 154.21200000000002 69.293 L 153.76500000000001 70.96700000000001 L 155.108 70.96700000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 139.33 51.62)",
    id: "MpqkzFCg3OjEYrVSNmaap"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-161.47, -71.04)",
    d: "M 159.253 68.148 L 160.67899999999997 68.148 L 161.58999999999997 70.603 L 163.82899999999998 68.148 L 165.23799999999997 68.148 L 163.69599999999997 73.935 L 162.38699999999997 73.935 L 163.39699999999996 70.155 L 161.06099999999995 72.625 L 161.02699999999996 72.625 L 160.01599999999996 70.188 L 159.00399999999996 73.935 L 157.71099999999996 73.935 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 146.71 51.62)",
    id: "acQjXYK8oca7tdnN1fDAD"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-168.84, -71.04)",
    d: "M 167.244 71.647 L 165.885 68.14800000000001 L 167.41 68.14800000000001 L 168.22299999999998 70.47000000000001 L 170.295 68.14800000000001 L 171.80499999999998 68.14800000000001 L 168.57099999999997 71.63000000000001 L 167.93999999999997 73.93500000000002 L 166.63099999999997 73.93500000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 154.13 51.61)",
    id: "iBpr0Kv9x9liOTqMcoyGv"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-176.27, -71.04)",
    d: "M 174.755 68.148 L 177.49099999999999 68.148 C 178.254 68.148 178.784 68.347 179.083 68.728 C 179.331 69.05999999999999 179.397 69.49199999999999 179.248 70.05499999999999 L 179.248 70.07199999999999 C 179.11499999999998 70.53599999999999 178.89999999999998 70.91799999999999 178.58499999999998 71.216 C 178.26999999999998 71.515 177.90499999999997 71.72999999999999 177.49099999999999 71.862 L 178.403 73.934 L 176.843 73.934 L 176.065 72.078 L 176.048 72.078 L 175.02 72.078 L 174.523 73.934 L 173.212 73.934 L 174.755 68.148 z M 176.646 70.967 C 176.97699999999998 70.967 177.243 70.902 177.458 70.736 C 177.673 70.587 177.806 70.387 177.87199999999999 70.13900000000001 L 177.87199999999999 70.12100000000001 C 177.938 69.84 177.90499999999997 69.641 177.772 69.492 C 177.623 69.358 177.391 69.293 177.076 69.293 L 175.766 69.293 L 175.319 70.96700000000001 L 176.646 70.96700000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 160.13 51.62)",
    id: "JVX1WSUQb5de4oqiMHcsd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-182.27, -71.04)",
    d: "M 180.79 68.148 L 185.29999999999998 68.148 L 184.98499999999999 69.27499999999999 L 181.785 69.27499999999999 L 181.47 70.45299999999999 L 184.288 70.45299999999999 L 183.99 71.58099999999999 L 181.172 71.58099999999999 L 180.84 72.80799999999999 L 184.09 72.80799999999999 L 183.791 73.93499999999999 L 179.248 73.93499999999999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 165.34 51.62)",
    id: "Dekq7VSctX0xkX_nv3Rl7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-187.48, -71.05)",
    d: "M 186.925 74.018 C 186.461 74.018 186.04600000000002 73.935 185.649 73.786 C 185.252 73.638 184.92 73.405 184.637 73.09100000000001 L 185.649 72.19500000000001 C 185.864 72.411 186.096 72.57600000000001 186.362 72.709 C 186.611 72.842 186.909 72.89200000000001 187.25799999999998 72.89200000000001 C 187.539 72.89200000000001 187.755 72.84200000000001 187.938 72.74300000000001 C 188.11999999999998 72.64300000000001 188.219 72.51100000000001 188.26899999999998 72.346 L 188.26899999999998 72.32900000000001 C 188.28599999999997 72.24600000000001 188.30199999999996 72.18 188.28599999999997 72.11300000000001 C 188.26999999999998 72.04600000000002 188.21999999999997 71.99700000000001 188.15399999999997 71.93 C 188.08799999999997 71.88000000000001 187.97099999999998 71.81400000000001 187.82199999999997 71.76400000000001 C 187.67299999999997 71.71400000000001 187.48999999999998 71.64900000000002 187.259 71.599 C 186.97699999999998 71.516 186.72799999999998 71.432 186.49599999999998 71.35000000000001 C 186.27999999999997 71.26700000000001 186.09799999999998 71.15100000000001 185.94799999999998 71.03500000000001 C 185.81599999999997 70.903 185.71699999999998 70.73700000000001 185.683 70.555 C 185.63299999999998 70.35600000000001 185.65 70.123 185.733 69.84200000000001 L 185.733 69.82500000000002 C 185.798 69.55900000000001 185.916 69.32800000000002 186.08100000000002 69.11200000000002 C 186.247 68.89600000000003 186.43 68.71400000000003 186.662 68.56500000000003 C 186.893 68.41600000000003 187.142 68.29900000000002 187.425 68.21600000000002 C 187.70600000000002 68.13300000000002 187.988 68.08300000000003 188.303 68.08300000000003 C 188.73499999999999 68.08300000000003 189.132 68.14900000000003 189.464 68.26600000000003 C 189.795 68.39900000000003 190.094 68.56500000000004 190.326 68.81300000000003 L 189.381 69.77500000000003 C 189.165 69.59200000000003 188.934 69.46000000000004 188.701 69.36000000000003 C 188.469 69.26100000000002 188.236 69.21200000000003 187.97199999999998 69.21200000000003 C 187.706 69.21200000000003 187.50799999999998 69.26200000000003 187.35899999999998 69.36000000000003 C 187.20999999999998 69.46000000000002 187.10999999999999 69.57600000000002 187.07699999999997 69.72500000000002 L 187.07699999999997 69.74200000000002 C 187.05999999999997 69.84200000000001 187.04399999999998 69.92500000000003 187.05999999999997 69.99000000000002 C 187.07699999999997 70.05700000000002 187.12599999999998 70.12300000000002 187.20899999999997 70.17400000000002 C 187.29099999999997 70.22300000000003 187.408 70.27300000000002 187.57299999999998 70.32200000000002 C 187.72199999999998 70.37200000000001 187.92199999999997 70.42200000000001 188.171 70.50500000000002 C 188.452 70.58800000000002 188.701 70.67100000000002 188.917 70.77100000000003 C 189.132 70.87000000000003 189.298 70.98600000000003 189.431 71.11900000000003 C 189.56300000000002 71.25200000000002 189.64600000000002 71.41800000000003 189.68 71.60000000000002 C 189.71200000000002 71.78200000000002 189.696 71.99700000000003 189.62900000000002 72.24600000000002 L 189.62900000000002 72.26300000000002 C 189.54600000000002 72.54400000000003 189.431 72.81000000000002 189.26500000000001 73.02600000000002 C 189.09900000000002 73.24100000000003 188.9 73.44000000000003 188.668 73.58900000000003 C 188.436 73.73800000000003 188.171 73.85500000000003 187.889 73.93700000000003 C 187.555 73.968 187.257 74.018 186.925 74.018",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 171.01 51.62)",
    id: "s73mwM8ELf2cntmievUpA"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-193.15, -71.04)",
    d: "M 191.684 68.148 L 196.177 68.148 L 195.878 69.27499999999999 L 192.67899999999997 69.27499999999999 L 192.36299999999997 70.45299999999999 L 195.18199999999996 70.45299999999999 L 194.88299999999995 71.58099999999999 L 192.04799999999994 71.58099999999999 L 191.73199999999994 72.80799999999999 L 194.98199999999994 72.80799999999999 L 194.66799999999995 73.93499999999999 L 190.12499999999994 73.93499999999999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 176.07 51.6)",
    id: "BWs_RYlzZtmvw1o8_WlQi"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-198.21, -71.02)",
    d: "M 199.161 68.115 L 200.371 68.115 L 201.382 73.934 L 200.007 73.934 L 199.808 72.64099999999999 L 197.272 72.64099999999999 L 196.376 73.934 L 195.032 73.934 L 199.161 68.115 z M 199.642 71.515 L 199.344 69.641 L 198.04999999999998 71.515 L 199.642 71.515 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 182.78 51.61)",
    id: "MfLyFIR8HIzCGfjJ-IVOR"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-204.92, -71.04)",
    d: "M 203.389 68.148 L 206.125 68.148 C 206.888 68.148 207.418 68.347 207.717 68.728 C 207.965 69.05999999999999 208.01500000000001 69.49199999999999 207.882 70.05499999999999 L 207.882 70.07199999999999 C 207.749 70.53599999999999 207.534 70.91799999999999 207.219 71.216 C 206.904 71.515 206.53799999999998 71.72999999999999 206.125 71.862 L 207.036 73.934 L 205.494 73.934 L 204.716 72.078 L 204.699 72.078 L 203.687 72.078 L 203.18900000000002 73.934 L 201.87900000000002 73.934 L 203.389 68.148 z M 205.279 70.967 C 205.60999999999999 70.967 205.876 70.902 206.091 70.736 C 206.30700000000002 70.587 206.44 70.387 206.506 70.13900000000001 L 206.506 70.12100000000001 C 206.572 69.84 206.538 69.641 206.406 69.492 C 206.257 69.358 206.025 69.293 205.693 69.293 L 204.383 69.293 L 203.935 70.96700000000001 L 205.279 70.96700000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 189.11 51.62)",
    id: "trznJS_HwO2GkhEL9EF3Y"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-211.25, -71.05)",
    d: "M 210.552 74.034 C 210.12 74.034 209.72299999999998 73.95100000000001 209.391 73.80300000000001 C 209.06 73.65400000000001 208.79399999999998 73.43800000000002 208.57899999999998 73.17300000000002 C 208.38099999999997 72.90700000000001 208.248 72.59200000000001 208.19799999999998 72.22800000000002 C 208.14799999999997 71.86300000000003 208.165 71.48200000000003 208.28099999999998 71.06700000000002 L 208.28099999999998 71.05 C 208.397 70.636 208.57899999999998 70.25399999999999 208.82799999999997 69.89 C 209.07699999999997 69.525 209.37499999999997 69.21 209.72399999999996 68.94500000000001 C 210.07199999999997 68.679 210.45299999999997 68.465 210.88399999999996 68.299 C 211.31599999999995 68.15 211.74599999999995 68.06700000000001 212.20999999999995 68.06700000000001 C 212.49199999999996 68.06700000000001 212.74099999999996 68.084 212.95599999999996 68.13300000000001 C 213.17199999999997 68.183 213.37099999999995 68.233 213.53699999999995 68.31600000000002 C 213.70199999999994 68.39900000000002 213.85099999999994 68.48200000000001 213.98399999999995 68.59800000000001 C 214.11699999999996 68.71300000000001 214.23299999999995 68.82900000000001 214.33299999999994 68.96200000000002 L 213.23799999999994 69.89100000000002 C 213.05499999999995 69.69200000000002 212.85599999999994 69.52600000000002 212.65799999999993 69.41100000000002 C 212.44199999999992 69.29500000000002 212.19299999999993 69.24500000000002 211.89499999999992 69.24500000000002 C 211.64599999999993 69.24500000000002 211.3979999999999 69.29500000000002 211.1659999999999 69.37700000000002 C 210.9339999999999 69.47700000000002 210.7009999999999 69.59300000000002 210.5029999999999 69.75900000000003 C 210.3039999999999 69.92500000000003 210.1379999999999 70.10700000000003 209.98799999999991 70.33900000000003 C 209.8389999999999 70.55500000000002 209.73999999999992 70.78600000000003 209.67399999999992 71.03500000000003 L 209.67399999999992 71.05200000000002 C 209.60799999999992 71.30100000000002 209.59099999999992 71.53200000000002 209.60799999999992 71.74900000000002 C 209.6409999999999 71.96400000000003 209.7079999999999 72.16300000000003 209.80699999999993 72.32900000000002 C 209.90599999999992 72.49500000000002 210.05599999999993 72.62700000000002 210.25399999999993 72.72600000000003 C 210.43699999999993 72.82600000000002 210.66799999999992 72.87500000000003 210.91699999999994 72.87500000000003 C 211.26499999999996 72.87500000000003 211.56299999999993 72.80900000000003 211.82899999999995 72.69200000000002 C 212.09399999999994 72.55900000000003 212.37599999999995 72.41100000000002 212.65799999999996 72.19500000000002 L 213.27099999999996 73.00700000000002 C 213.07199999999995 73.17300000000002 212.87399999999997 73.30500000000002 212.67399999999995 73.43800000000002 C 212.47399999999993 73.57100000000001 212.25899999999996 73.67000000000002 212.04399999999995 73.77000000000001 C 211.82799999999995 73.86900000000001 211.59599999999995 73.93500000000002 211.34699999999995 73.98500000000001 C 211.099 74.018 210.833 74.034 210.552 74.034",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 194.99 51.62)",
    id: "Mxg7sMHBfqECo7ommX0eV"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-217.13, -71.04)",
    d: "M 215.376 68.148 L 216.702 68.148 L 216.089 70.437 L 218.51 70.437 L 219.123 68.148 L 220.433 68.148 L 218.891 73.935 L 217.581 73.935 L 218.194 71.613 L 215.773 71.613 L 215.145 73.935 L 213.834 73.935 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 123.35 59.84)",
    id: "pCPQ0DKtOd7C1cnovQgpL"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-145.49, -79.27)",
    d: "M 144.729 76.372 L 146.056 76.372 L 144.812 80.998 L 147.79600000000002 80.998 L 147.48100000000002 82.158 L 143.187 82.158 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 128.98 59.82)",
    id: "AXDd2v71eBRL2ujlaRzo5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-151.12, -79.25)",
    d: "M 152.074 76.339 L 153.28400000000002 76.339 L 154.29600000000002 82.158 L 152.92000000000002 82.158 L 152.721 80.865 L 150.184 80.865 L 149.288 82.158 L 147.94500000000002 82.158 L 152.074 76.339 z M 152.538 79.738 L 152.24 77.864 L 150.946 79.738 L 152.538 79.738 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 135.82 59.84)",
    id: "3og9DJGU9SxCB8HqXS5V9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-157.96, -79.27)",
    d: "M 156.534 76.372 L 159.303 76.372 C 159.999 76.372 160.464 76.538 160.72899999999998 76.886 C 160.928 77.152 160.97799999999998 77.484 160.878 77.865 L 160.878 77.88199999999999 C 160.795 78.21399999999998 160.646 78.46199999999999 160.44699999999997 78.66099999999999 C 160.24799999999996 78.85999999999999 160.015 79.00999999999999 159.76599999999996 79.12499999999999 C 159.91499999999996 79.19199999999998 160.04799999999997 79.25799999999998 160.16399999999996 79.34099999999998 C 160.27999999999994 79.42399999999998 160.37999999999997 79.52399999999999 160.44599999999997 79.63999999999999 C 160.51099999999997 79.75599999999999 160.54499999999996 79.88799999999999 160.56099999999998 80.03699999999999 C 160.577 80.18599999999999 160.54399999999998 80.35199999999999 160.49499999999998 80.55099999999999 L 160.49499999999998 80.56799999999998 C 160.42899999999997 80.83399999999999 160.31199999999998 81.06599999999999 160.14699999999996 81.26499999999999 C 159.98099999999997 81.46299999999998 159.79799999999997 81.62899999999999 159.56599999999997 81.76199999999999 C 159.33499999999998 81.89499999999998 159.06899999999996 81.99399999999999 158.771 82.05999999999999 C 158.47199999999998 82.12599999999999 158.15699999999998 82.15999999999998 157.826 82.15999999999998 L 154.99099999999999 82.15999999999998 L 156.534 76.372 z M 158.126 81.048 C 158.424 81.048 158.656 80.998 158.85500000000002 80.899 C 159.05300000000003 80.799 159.169 80.633 159.23600000000002 80.419 L 159.23600000000002 80.402 C 159.28600000000003 80.203 159.25300000000001 80.053 159.13600000000002 79.938 C 159.00300000000001 79.822 158.77200000000002 79.772 158.44000000000003 79.772 L 156.91500000000002 79.772 L 156.56600000000003 81.048 L 158.126 81.048 z M 158.407 78.71 C 158.705 78.71 158.93800000000002 78.66 159.13600000000002 78.56099999999999 C 159.33500000000004 78.461 159.46800000000002 78.312 159.51800000000003 78.097 L 159.51800000000003 78.08 C 159.56700000000004 77.881 159.53500000000003 77.731 159.41800000000003 77.632 C 159.30200000000002 77.533 159.10300000000004 77.48400000000001 158.82000000000002 77.48400000000001 L 157.52800000000002 77.48400000000001 L 157.19600000000003 78.71100000000001 L 158.407 78.71100000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 142.51 59.85)",
    id: "gCKWb36idDS936G9bnj1a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-164.65, -79.27)",
    d: "M 163.829 82.258 C 163.365 82.258 162.967 82.176 162.619 82.027 C 162.27 81.878 161.988 81.662 161.79 81.396 C 161.57399999999998 81.131 161.441 80.816 161.392 80.452 C 161.326 80.087 161.359 79.706 161.475 79.291 L 161.475 79.274 C 161.591 78.86 161.774 78.478 162.022 78.114 C 162.271 77.74900000000001 162.58599999999998 77.434 162.934 77.16900000000001 C 163.283 76.903 163.68 76.68900000000001 164.112 76.52300000000001 C 164.543 76.37400000000001 164.98999999999998 76.29100000000001 165.45499999999998 76.29100000000001 C 165.91899999999998 76.29100000000001 166.31699999999998 76.37400000000001 166.665 76.52300000000001 C 167.01399999999998 76.67200000000001 167.296 76.88700000000001 167.494 77.153 C 167.71 77.41900000000001 167.842 77.733 167.908 78.098 C 167.975 78.462 167.94099999999997 78.844 167.826 79.258 L 167.826 79.27499999999999 C 167.70999999999998 79.69 167.527 80.071 167.278 80.43599999999999 C 167.03 80.8 166.715 81.116 166.367 81.38 C 166.018 81.646 165.62099999999998 81.86 165.189 82.027 C 164.758 82.192 164.294 82.258 163.829 82.258 M 164.16 81.081 C 164.426 81.081 164.691 81.031 164.923 80.94800000000001 C 165.172 80.84800000000001 165.388 80.73200000000001 165.586 80.566 C 165.78500000000003 80.401 165.96800000000002 80.218 166.101 79.986 C 166.25 79.771 166.35 79.539 166.415 79.29 L 166.415 79.27300000000001 C 166.481 79.025 166.498 78.793 166.46599999999998 78.57700000000001 C 166.432 78.36200000000001 166.36599999999999 78.16300000000001 166.24999999999997 77.99700000000001 C 166.13399999999996 77.83100000000002 165.96799999999996 77.69800000000001 165.78499999999997 77.60000000000001 C 165.58599999999996 77.50000000000001 165.35399999999996 77.45100000000001 165.08899999999997 77.45100000000001 C 164.82399999999998 77.45100000000001 164.57499999999996 77.501 164.32599999999996 77.584 C 164.07699999999997 77.684 163.86199999999997 77.799 163.64599999999996 77.965 C 163.44799999999995 78.131 163.26499999999996 78.33 163.13099999999997 78.545 C 162.98299999999998 78.761 162.88299999999998 78.993 162.81699999999998 79.241 L 162.81699999999998 79.258 C 162.75099999999998 79.50699999999999 162.73399999999998 79.73899999999999 162.76699999999997 79.954 C 162.79999999999995 80.16999999999999 162.86699999999996 80.369 162.98299999999998 80.535 C 163.099 80.7 163.265 80.833 163.44799999999998 80.932 C 163.663 81.031 163.896 81.081 164.16 81.081",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 148.97 59.84)",
    id: "CbAQi0OdSJivveVXmdlw0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-171.11, -79.27)",
    d: "M 169.582 76.372 L 172.31799999999998 76.372 C 173.07999999999998 76.372 173.611 76.571 173.91 76.952 C 174.158 77.28399999999999 174.224 77.715 174.075 78.279 L 174.075 78.295 C 173.94199999999998 78.76 173.72699999999998 79.141 173.41199999999998 79.44 C 173.09699999999998 79.73899999999999 172.73199999999997 79.954 172.31799999999998 80.086 L 173.23 82.158 L 171.68699999999998 82.158 L 170.908 80.302 L 170.892 80.302 L 169.88 80.302 L 169.38299999999998 82.158 L 168.07199999999997 82.158 L 169.582 76.372 z M 171.473 79.191 C 171.805 79.191 172.07000000000002 79.108 172.28500000000003 78.959 C 172.50000000000003 78.81 172.63300000000004 78.61 172.699 78.36200000000001 L 172.699 78.34500000000001 C 172.76500000000001 78.06300000000002 172.732 77.86400000000002 172.59900000000002 77.71400000000001 C 172.45000000000002 77.58200000000001 172.21800000000002 77.49900000000001 171.88600000000002 77.49900000000001 L 170.57600000000002 77.49900000000001 L 170.12900000000002 79.174 L 171.472 79.174 L 171.472 79.191 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 154.51 59.82)",
    id: "ayL9XwOcOZFtVs8u0-OVd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-176.65, -79.25)",
    d: "M 177.606 76.339 L 178.817 76.339 L 179.829 82.158 L 178.452 82.158 L 178.254 80.865 L 175.71699999999998 80.865 L 174.821 82.158 L 173.478 82.158 L 177.606 76.339 z M 178.071 79.738 L 177.773 77.864 L 176.47899999999998 79.738 L 178.071 79.738 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 161.12 59.84)",
    id: "l-NPpbkVUWTqOa3SWshgH"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-183.26, -79.27)",
    d: "M 182.448 77.549 L 180.624 77.549 L 180.939 76.372 L 185.896 76.372 L 185.582 77.549 L 183.75799999999998 77.549 L 182.53099999999998 82.158 L 181.20499999999998 82.158 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 166.53 59.85)",
    id: "j3_KykRUe0kZj1OTHZI91"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-188.67, -79.27)",
    d: "M 187.854 82.258 C 187.389 82.258 186.99200000000002 82.176 186.643 82.027 C 186.295 81.878 186.013 81.662 185.815 81.396 C 185.59799999999998 81.131 185.466 80.816 185.417 80.452 C 185.351 80.087 185.38400000000001 79.706 185.5 79.291 L 185.5 79.274 C 185.616 78.86 185.798 78.478 186.047 78.114 C 186.296 77.74900000000001 186.611 77.434 186.959 77.16900000000001 C 187.308 76.903 187.705 76.68900000000001 188.136 76.52300000000001 C 188.56799999999998 76.35700000000001 189.016 76.29100000000001 189.48 76.29100000000001 C 189.944 76.29100000000001 190.34199999999998 76.37400000000001 190.69 76.52300000000001 C 191.039 76.67200000000001 191.32 76.88700000000001 191.519 77.153 C 191.735 77.41900000000001 191.868 77.733 191.917 78.098 C 191.982 78.462 191.949 78.844 191.834 79.258 L 191.834 79.27499999999999 C 191.718 79.69 191.535 80.071 191.286 80.43599999999999 C 191.038 80.8 190.723 81.116 190.374 81.38 C 190.02599999999998 81.646 189.628 81.86 189.197 82.027 C 188.766 82.176 188.317 82.258 187.854 82.258 M 188.186 81.081 C 188.451 81.081 188.716 81.031 188.948 80.94800000000001 C 189.197 80.84800000000001 189.413 80.73200000000001 189.612 80.566 C 189.81 80.401 189.993 80.218 190.126 79.986 C 190.275 79.771 190.374 79.539 190.441 79.29 L 190.441 79.27300000000001 C 190.506 79.025 190.523 78.793 190.49 78.57700000000001 C 190.45700000000002 78.36200000000001 190.39000000000001 78.16300000000001 190.275 77.99700000000001 C 190.15800000000002 77.83100000000002 189.993 77.69800000000001 189.81 77.60000000000001 C 189.612 77.50000000000001 189.379 77.45100000000001 189.114 77.45100000000001 C 188.84900000000002 77.45100000000001 188.6 77.501 188.351 77.584 C 188.103 77.684 187.887 77.799 187.671 77.965 C 187.47199999999998 78.131 187.289 78.33 187.15699999999998 78.545 C 187.00799999999998 78.761 186.908 78.993 186.84199999999998 79.241 L 186.84199999999998 79.258 C 186.77599999999998 79.50699999999999 186.76 79.73899999999999 186.79199999999997 79.954 C 186.82499999999996 80.16999999999999 186.89199999999997 80.369 187.00799999999998 80.535 C 187.124 80.7 187.289 80.833 187.47199999999998 80.932 C 187.704 81.031 187.937 81.081 188.186 81.081",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 173 59.84)",
    id: "lDOOQ2gRV2yOemomb265D"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-195.14, -79.27)",
    d: "M 193.606 76.372 L 196.34199999999998 76.372 C 197.105 76.372 197.635 76.571 197.933 76.952 C 198.182 77.28399999999999 198.248 77.715 198.099 78.279 L 198.099 78.295 C 197.96599999999998 78.76 197.75099999999998 79.141 197.43599999999998 79.44 C 197.12199999999999 79.739 196.75599999999997 79.954 196.34199999999998 80.086 L 197.253 82.158 L 195.71099999999998 82.158 L 194.933 80.302 L 194.915 80.302 L 193.904 80.302 L 193.406 82.158 L 192.096 82.158 L 193.606 76.372 z M 195.514 79.191 C 195.845 79.191 196.11100000000002 79.108 196.32600000000002 78.959 C 196.54200000000003 78.81 196.675 78.61 196.741 78.36200000000001 L 196.741 78.34500000000001 C 196.80700000000002 78.06300000000002 196.77300000000002 77.86400000000002 196.64100000000002 77.71400000000001 C 196.49200000000002 77.58200000000001 196.26000000000002 77.49900000000001 195.92800000000003 77.49900000000001 L 194.61800000000002 77.49900000000001 L 194.17000000000002 79.174 L 195.514 79.174 L 195.514 79.191 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 179.57 59.84)",
    id: "_Cs7BAEBDth3XDXAgkldG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-201.71, -79.27)",
    d: "M 200.106 79.87 L 198.74599999999998 76.372 L 200.28799999999998 76.372 L 201.08399999999997 78.693 L 203.17299999999997 76.372 L 204.66499999999996 76.372 L 201.43299999999996 79.854 L 200.81799999999996 82.158 L 199.49199999999996 82.158 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 19.25)",
    id: "o6N_2SytIyABBFXt-r9FM"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -38.67)",
    d: "M 73.522 54.71 L 73.522 22.616 L 25.335 22.616 L 25.335 54.729 C 32.572 51.073 40.773 49 49.429 49 C 58.103 49 66.285 51.055 73.522 54.71",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 48.48)",
    id: "bSWau8dYFhXzl6-Sj9pAL"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(159,161,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -67.9)",
    d: "M 32.663 78.604 C 36.827 82.386 42.754999999999995 85.295 49.428999999999995 86.823 C 56.102999999999994 85.29599999999999 62.029999999999994 82.386 66.195 78.604 C 71.068 74.185 73.523 68.711 73.523 62.33 L 73.523 54.71 C 66.286 51.055 58.084999999999994 48.982 49.428999999999995 48.982 C 40.754999999999995 48.982 32.57299999999999 51.037 25.334999999999994 54.71 L 25.334999999999994 62.329 C 25.335 68.693 27.79 74.166 32.663 78.604",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.24 19.24)",
    id: "Jeqv5I96A6LpfpZegnaV6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(1,1,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-37.38, -38.66)",
    d: "M 25.335 54.71 L 25.335 34.744 L 49.429 22.616 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 35.29)",
    id: "CuoToqZ8hv6b9IS0og_a8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(1,1,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -54.72)",
    d: "M 64.758 79.821 C 57.485 52.674 49.428999999999995 22.614999999999995 49.428999999999995 22.614999999999995 L 34.1 79.821 C 38.137 83.021 43.501000000000005 85.476 49.429 86.822 C 55.356 85.458 60.721 83.004 64.758 79.821",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 39.34 19.24)",
    id: "gqip9uKhAiqxuoAP8j5nG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(1,1,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-61.48, -38.66)",
    d: "M 73.522 54.71 L 73.522 34.744 L 49.429 22.616 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 35.32)",
    id: "WeMk3Ao7DGWF7PLGYkGVQ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(1,1,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -54.75)",
    d: "M 73.522 62.329 C 73.522 68.693 71.048 74.166 66.194 78.60300000000001 C 62.029 82.385 56.102000000000004 85.29400000000001 49.428000000000004 86.822 C 42.754000000000005 85.295 36.82600000000001 82.385 32.662000000000006 78.60300000000001 C 27.789000000000005 74.18400000000001 25.334000000000007 68.71000000000001 25.334000000000007 62.32900000000001 L 25.334000000000007 22.616 L 73.54 22.616 L 73.54 62.329 L 73.522 62.329 z M 22.644 19.924 L 22.644 62.329 C 22.644 77.658 35.608999999999995 86.586 49.429 89.568 C 63.249 86.586 76.214 77.675 76.214 62.346 L 76.214 19.924 L 22.644 19.924 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 63.72)",
    id: "py-Owtrw8zlFoiUgOAd8G"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(64,64,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -83.15)",
    d: "M 64.667 79.494 C 60.666000000000004 82.67699999999999 55.32 85.149 49.429 86.514 C 43.519000000000005 85.14999999999999 38.192 82.695 34.191 79.494 L 34.1 79.804 C 38.137 83.004 43.501000000000005 85.458 49.429 86.804 C 55.358000000000004 85.458 60.721000000000004 83.004 64.75800000000001 79.804 L 64.75800000000001 79.785 C 64.721 79.694 64.703 79.604 64.667 79.494",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.34 25.23)",
    id: "YobJRT0Dtdcz32ZXMZrjn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(64,64,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-25.48, -44.65)",
    d: "M 25.626 34.599 L 25.335 34.744 L 25.335 54.71 L 25.626 54.31 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.24 25.23)",
    id: "3u8KuYF_b9m7XeYi0rBc7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(64,64,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-73.38, -44.65)",
    d: "M 73.231 34.599 L 73.52199999999999 34.744 L 73.52199999999999 54.71 L 73.231 54.31 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 47.57)",
    id: "DqpCGJCvU15vnDT29eoMI"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(252,191,21)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -66.99)",
    d: "M 60.212 73.439 L 60.212 71.857 L 59.976000000000006 71.22 C 57.95700000000001 71.148 55.01100000000001 69.402 53.52 67.037 L 53.52 67.019 C 53.52 64.581 56.612 64.4 60.394000000000005 63.545 L 70.849 57.6 L 70.467 57.072 L 59.503 57.072 L 59.248 56.727000000000004 L 39.609 56.727000000000004 L 38.718 57.963 L 28.008 57.963 C 29.808999999999997 60.182 32.372 61.636 35.373 62.691 C 36.428 63.055 37.464 63.328 38.464 63.564 C 42.245999999999995 64.418 45.338 64.619 45.338 67.037 L 45.338 67.05600000000001 C 43.828 69.40200000000002 40.9 71.165 38.882 71.239 L 38.646 71.876 L 38.646 73.45700000000001 C 38.446 73.53 38.228 73.60300000000001 37.992 73.676 L 37.791999999999994 74.239 L 37.791999999999994 77.257 L 43.519999999999996 77.257 C 44.357 76.421 46.848 75.022 49.42999999999999 75.022 C 52.011999999999986 75.022 54.50299999999999 76.421 55.33899999999999 77.257 L 61.06799999999999 77.257 L 61.06799999999999 74.239 L 60.86799999999999 73.676 C 60.647 73.585 60.431 73.512 60.212 73.439",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 19.42 51.19)",
    id: "d3XxmEwdyrJ821edfGYS1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-41.56, -70.62)",
    d: "M 40.482 72.148 C 40.482 71.76599999999999 39.7 71.675 38.644999999999996 71.857 L 38.88099999999999 71.22 C 40.89999999999999 71.148 43.84499999999999 69.402 45.336999999999996 67.037 C 45.318 70.783 40.589999999999996 74.20200000000001 37.79 74.20200000000001 L 37.99 73.63800000000002 C 39.373 73.257 40.482 72.585 40.482 72.148",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.27 47.55)",
    id: "fQX16HHpGYP72Hwu98qxT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.41, -66.97)",
    d: "M 61.066 77.403 L 55.337 77.403 C 55.301 77.403 55.247 77.384 55.21 77.348 C 54.337 76.457 51.882 75.166 49.428 75.166 C 46.973 75.166 44.518 76.475 43.646 77.348 C 43.61 77.384 43.573 77.403 43.518 77.403 L 37.79 77.403 C 37.699 77.403 37.627 77.331 37.627 77.239 L 37.627 74.22 C 37.627 74.202 37.627 74.184 37.645 74.16499999999999 L 37.845000000000006 73.60199999999999 C 37.86300000000001 73.54799999999999 37.900000000000006 73.511 37.95400000000001 73.49399999999999 C 38.13600000000001 73.43899999999998 38.31700000000001 73.38499999999999 38.48100000000001 73.32999999999998 L 38.48100000000001 71.87599999999999 C 38.48100000000001 71.85699999999999 38.48100000000001 71.83899999999998 38.49900000000001 71.82099999999998 L 38.73500000000001 71.18399999999998 C 38.754000000000005 71.11099999999999 38.827000000000005 71.07499999999999 38.88100000000001 71.07499999999999 C 40.95400000000001 71.002 43.77300000000001 69.18399999999998 45.17200000000001 67.01999999999998 C 45.137000000000015 65.12799999999999 43.02600000000001 64.69299999999998 40.11800000000001 64.09199999999998 C 39.57200000000001 63.98299999999998 39.00900000000001 63.85599999999999 38.42700000000001 63.728999999999985 C 37.227000000000004 63.45599999999998 36.227000000000004 63.182999999999986 35.318000000000005 62.85599999999999 C 31.972000000000005 61.655999999999985 29.536000000000005 60.09099999999999 27.880000000000006 58.054999999999986 C 27.844000000000005 57.999999999999986 27.825000000000006 57.92799999999998 27.861000000000008 57.87299999999998 C 27.89700000000001 57.817999999999984 27.953000000000007 57.78199999999998 28.00700000000001 57.78199999999998 L 38.62700000000001 57.78199999999998 L 39.46300000000001 56.61799999999998 C 39.49900000000001 56.58199999999998 39.53500000000001 56.54499999999998 39.59000000000001 56.54499999999998 L 59.22900000000001 56.54499999999998 C 59.28400000000001 56.54499999999998 59.338000000000015 56.56399999999998 59.356000000000016 56.61799999999998 L 59.55600000000002 56.90899999999998 L 70.43100000000001 56.90899999999998 C 70.48500000000001 56.90899999999998 70.53900000000002 56.927999999999976 70.55700000000002 56.98199999999998 L 70.94000000000001 57.50799999999998 C 70.97600000000001 57.54499999999998 70.97600000000001 57.59999999999998 70.97600000000001 57.63599999999998 C 70.95700000000001 57.69099999999998 70.94000000000001 57.72699999999998 70.90400000000001 57.74499999999998 L 60.44800000000001 63.68999999999998 C 60.42900000000001 63.68999999999998 60.412000000000006 63.70899999999998 60.412000000000006 63.70899999999998 C 59.830000000000005 63.835999999999984 59.266000000000005 63.963999999999984 58.721000000000004 64.07199999999999 C 55.812000000000005 64.67299999999999 53.702000000000005 65.109 53.665000000000006 66.99999999999999 C 55.065000000000005 69.16399999999999 57.88400000000001 70.98199999999999 59.95700000000001 71.05499999999998 C 60.02900000000001 71.05499999999998 60.08500000000001 71.10999999999999 60.10300000000001 71.16399999999997 L 60.339000000000006 71.80099999999997 C 60.339000000000006 71.81999999999998 60.357000000000006 71.83699999999997 60.357000000000006 71.85599999999998 L 60.357000000000006 73.30999999999997 C 60.52100000000001 73.36499999999998 60.703 73.43799999999997 60.885000000000005 73.47399999999998 C 60.93900000000001 73.49299999999998 60.976000000000006 73.52899999999998 60.993 73.58299999999997 L 61.193000000000005 74.14599999999997 C 61.193000000000005 74.16399999999997 61.212 74.18199999999997 61.212 74.20099999999998 L 61.212 77.21999999999998 C 61.248 77.331 61.157 77.403 61.066 77.403 M 55.411 77.058 L 60.902 77.058 L 60.902 74.24000000000001 L 60.739000000000004 73.78500000000001 C 60.538000000000004 73.73100000000001 60.339000000000006 73.65800000000002 60.157000000000004 73.58600000000001 C 60.085 73.56800000000001 60.048 73.49500000000002 60.048 73.42200000000001 L 60.048 71.87700000000001 L 59.866 71.38600000000001 C 57.702 71.25800000000001 54.811 69.367 53.391999999999996 67.13100000000001 C 53.373 67.11200000000001 53.373 67.07600000000001 53.373 67.03900000000002 C 53.373 64.82100000000001 55.718999999999994 64.34900000000002 58.683 63.73000000000002 C 59.21 63.621000000000016 59.775 63.51100000000002 60.356 63.38400000000002 L 70.63 57.529000000000025 L 70.41199999999999 57.22000000000003 L 59.539 57.22000000000003 C 59.484 57.22000000000003 59.43 57.20100000000003 59.411 57.14700000000003 L 59.211 56.85600000000003 L 39.682 56.85600000000003 L 38.846000000000004 58.02000000000003 C 38.81 58.05600000000003 38.774 58.092000000000034 38.718 58.092000000000034 L 28.372 58.092000000000034 C 29.99 59.94700000000003 32.3 61.38300000000003 35.427 62.49300000000004 C 36.336 62.820000000000036 37.3 63.09300000000004 38.5 63.34700000000004 C 39.082 63.47400000000004 39.646 63.601000000000035 40.191 63.710000000000036 C 43.155 64.32800000000003 45.501000000000005 64.80100000000003 45.501000000000005 67.00100000000003 C 45.501000000000005 67.03700000000003 45.482000000000006 67.09200000000003 45.482000000000006 67.11000000000003 C 44.06400000000001 69.34600000000003 41.172000000000004 71.21900000000002 39.00900000000001 71.36500000000002 L 38.827000000000005 71.85600000000002 L 38.827000000000005 73.40200000000003 C 38.827000000000005 73.47400000000003 38.790000000000006 73.52900000000002 38.717000000000006 73.56600000000003 C 38.535000000000004 73.63700000000003 38.33500000000001 73.69200000000004 38.136 73.76500000000003 L 37.973000000000006 74.21900000000002 L 37.973000000000006 77.03700000000002 L 43.464000000000006 77.03700000000002 C 44.428000000000004 76.11000000000001 46.937000000000005 74.80100000000002 49.446000000000005 74.80100000000002 C 51.938 74.821 54.447 76.148 55.411 77.058",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 17.42 53.17)",
    id: "TL5zYBWKAwxBMs6BlP7Iu"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-39.56, -72.6)",
    d: "M 40.482 72.148 C 40.482 72.53 39.7 73.057 38.644999999999996 73.439 L 38.644999999999996 71.857 C 39.719 71.657 40.5 71.767 40.482 72.148",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 17.44 53.16)",
    id: "dhb2g-o8eqrg3p8mYNpyv"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-39.58, -72.59)",
    d: "M 38.646 73.603 C 38.61 73.603 38.574 73.585 38.555 73.567 C 38.519 73.53099999999999 38.483 73.476 38.483 73.42099999999999 L 38.483 71.839 C 38.483 71.767 38.538 71.693 38.629 71.676 C 39.065 71.60300000000001 40.101 71.44 40.519999999999996 71.784 C 40.629 71.876 40.684 71.98400000000001 40.684 72.111 C 40.665 72.65700000000001 39.665 73.22 38.738 73.566 C 38.682 73.603 38.664 73.603 38.646 73.603 M 38.81 72.003 L 38.81 73.203 C 39.846000000000004 72.784 40.319 72.348 40.319 72.148 C 40.319 72.12899999999999 40.319 72.11099999999999 40.283 72.075 C 40.118 71.93 39.609 71.876 38.81 72.003",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 37.15 53.17)",
    id: "1x5VmXkN9bDt6OfpLCLZn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-59.29, -72.6)",
    d: "M 58.375 72.148 C 58.375 72.53 59.157 73.057 60.212 73.439 L 60.212 71.857 C 59.139 71.657 58.356 71.767 58.375 72.148",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 37.15 53.18)",
    id: "kBnA5atQNzMjJM7sjt1MN"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-59.29, -72.61)",
    d: "M 60.212 73.512 L 60.193000000000005 73.512 C 59.321000000000005 73.185 58.30200000000001 72.639 58.30200000000001 72.149 C 58.30200000000001 72.04 58.33800000000001 71.949 58.42900000000001 71.894 C 58.68400000000001 71.676 59.35600000000001 71.63900000000001 60.229000000000006 71.80300000000001 C 60.266000000000005 71.80300000000001 60.284000000000006 71.83900000000001 60.284000000000006 71.876 L 60.284000000000006 73.45700000000001 C 60.284000000000006 73.47600000000001 60.266000000000005 73.51200000000001 60.248000000000005 73.51200000000001 L 60.212 73.51200000000001 M 58.447 72.148 C 58.447 72.42 59.029 72.91199999999999 60.138000000000005 73.348 L 60.138000000000005 71.93 C 59.35600000000001 71.784 58.739000000000004 71.822 58.52 72.003 C 58.466 72.039 58.447 72.075 58.447 72.148",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 35.15 51.19)",
    id: "2yEOOTQpZzWUCuy8w14tn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-57.29, -70.62)",
    d: "M 58.375 72.148 C 58.375 71.76599999999999 59.157 71.675 60.212 71.857 L 59.975 71.22 C 57.957 71.148 55.011 69.402 53.52 67.037 C 53.539 70.783 58.267 74.20200000000001 61.067 74.20200000000001 L 60.866 73.63800000000002 C 59.484 73.257 58.375 72.585 58.375 72.148",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 35.16 51.21)",
    id: "5VcS2RWb37TfAMZasX1RE"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-57.3, -70.64)",
    d: "M 61.066 74.385 C 59.629000000000005 74.385 57.702000000000005 73.512 56.138000000000005 72.167 C 54.374 70.639 53.35600000000001 68.784 53.35600000000001 67.057 C 53.35600000000001 66.985 53.41100000000001 66.911 53.48400000000001 66.893 C 53.55600000000001 66.875 53.63000000000001 66.893 53.665000000000006 66.966 C 55.065000000000005 69.148 57.90200000000001 71.002 59.99300000000001 71.05699999999999 C 60.06600000000001 71.05699999999999 60.12100000000001 71.112 60.13900000000001 71.16599999999998 L 60.37500000000001 71.80299999999998 C 60.394000000000005 71.85799999999999 60.394000000000005 71.92999999999998 60.339000000000006 71.96599999999998 C 60.30200000000001 72.02099999999999 60.248000000000005 72.03899999999997 60.175000000000004 72.02099999999999 C 59.284000000000006 71.85799999999999 58.739000000000004 71.92999999999999 58.575 72.05799999999999 C 58.539 72.094 58.539 72.112 58.539 72.13 C 58.539 72.42099999999999 59.448 73.07499999999999 60.921 73.476 C 60.976 73.495 61.012 73.531 61.03 73.585 L 61.229 74.148 C 61.248 74.203 61.248 74.25699999999999 61.211 74.294 C 61.175 74.366 61.121 74.385 61.066 74.385 M 53.738 67.656 C 54.193 70.929 58.212 73.876 60.83 74.057 L 60.739 73.802 C 59.465999999999994 73.42 58.211999999999996 72.747 58.211999999999996 72.14800000000001 C 58.211999999999996 72.02000000000001 58.266999999999996 71.91100000000002 58.37499999999999 71.82100000000001 C 58.70199999999999 71.52900000000001 59.465999999999994 71.58400000000002 59.974999999999994 71.65700000000001 L 59.88399999999999 71.40200000000002 C 57.866 71.275 55.248 69.657 53.738 67.656",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 53.88)",
    id: "lDd37mH2Osh3k9xSMpT_L"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -73.3)",
    d: "M 49.429 74.984 C 46.847 74.984 44.356 76.384 43.52 77.22099999999999 L 43.52 74.20199999999998 C 44.356 73.36499999999998 47.374 69.38299999999998 49.429 69.38299999999998 C 51.484 69.38299999999998 54.502 73.36499999999998 55.338 74.20199999999998 L 55.338 77.22099999999999 C 54.502 76.403 52.011 74.984 49.429 74.984",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 53.9)",
    id: "oNunZXKjflx5IisoArvcG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -73.32)",
    d: "M 55.338 77.312 C 55.32 77.312 55.302 77.312 55.284 77.29299999999999 C 54.391999999999996 76.40199999999999 51.900999999999996 75.074 49.429 75.074 C 46.938 75.074 44.465 76.402 43.574 77.29299999999999 C 43.555 77.312 43.519999999999996 77.33 43.501999999999995 77.312 C 43.483999999999995 77.294 43.446999999999996 77.276 43.446999999999996 77.239 L 43.446999999999996 74.22 C 43.446999999999996 74.202 43.446999999999996 74.184 43.465999999999994 74.16499999999999 C 43.611999999999995 74.01899999999999 43.84799999999999 73.76599999999999 44.12 73.43799999999999 C 45.375 72.00099999999999 47.72 69.32799999999999 49.43 69.32799999999999 C 51.139 69.32799999999999 53.486 72.002 54.74 73.43799999999999 C 55.031 73.76499999999999 55.249 74.01899999999999 55.394000000000005 74.16499999999999 C 55.413000000000004 74.184 55.413000000000004 74.202 55.413000000000004 74.22 L 55.413000000000004 77.239 C 55.413000000000004 77.27600000000001 55.394000000000005 77.29400000000001 55.358000000000004 77.312 C 55.356 77.294 55.356 77.312 55.338 77.312 M 49.429 74.912 C 51.847 74.912 54.266000000000005 76.14800000000001 55.266000000000005 77.058 L 55.266000000000005 74.25800000000001 C 55.120000000000005 74.09400000000001 54.90200000000001 73.858 54.63 73.549 C 53.374 72.111 51.066 69.47500000000001 49.429 69.47500000000001 C 47.792 69.47500000000001 45.483000000000004 72.11200000000001 44.228 73.531 C 43.956 73.84 43.738 74.09400000000001 43.592 74.24000000000001 L 43.592 77.04 C 44.592 76.148 47.011 74.912 49.429 74.912",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.22 41.32)",
    id: "HnnJyhqdOjNdcplmFks76"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-33.36, -60.75)",
    d: "M 38.719 57.946 L 28.008 57.946 C 29.808999999999997 60.165 32.372 61.62 35.373 62.675 C 36.428 63.038 37.464 63.311 38.464 63.547 L 38.464 58.291999999999994 L 38.719 57.946 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.22 41.33)",
    id: "2TLt2VOF4t8RFPXWp7eqR"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-33.36, -60.76)",
    d: "M 38.464 63.729 L 38.428 63.729 C 37.227999999999994 63.455999999999996 36.227999999999994 63.183 35.318 62.856 C 31.971999999999998 61.656 29.537 60.091 27.880999999999997 58.055 C 27.844999999999995 58 27.825999999999997 57.928 27.862 57.873 C 27.898999999999997 57.818 27.953 57.782 28.008 57.782 L 38.719 57.782 C 38.773 57.782 38.846000000000004 57.818 38.865 57.873 C 38.901 57.928 38.883 58 38.846000000000004 58.055 L 38.628 58.365 L 38.628 63.565000000000005 C 38.628 63.620000000000005 38.609 63.656000000000006 38.573 63.69200000000001 C 38.537 63.711 38.5 63.729 38.464 63.729 M 28.372 58.11 C 29.99 59.964 32.299 61.400999999999996 35.428 62.51 C 36.282 62.82 37.192 63.073 38.3 63.327999999999996 L 38.3 58.291 C 38.3 58.254999999999995 38.318999999999996 58.218999999999994 38.336 58.199999999999996 L 38.391999999999996 58.108999999999995 L 28.372 58.108999999999995 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 43.23 41.15)",
    id: "sr3R7S5Zt9dWknKZhzXRQ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-65.37, -60.57)",
    d: "M 60.394 58.311 L 60.394 63.547 L 70.849 57.602 L 59.885000000000005 57.602 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 43.24 41.14)",
    id: "yHtQrY7lmvvBccNXRnNDd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-65.38, -60.57)",
    d: "M 60.394 63.62 C 60.375 63.62 60.375 63.62 60.358 63.601 C 60.339 63.583 60.321 63.565 60.321 63.528999999999996 L 60.321 58.309999999999995 L 59.830999999999996 57.61899999999999 C 59.812 57.60099999999999 59.812 57.56399999999999 59.830999999999996 57.54699999999999 C 59.849 57.52799999999999 59.867 57.51099999999999 59.903 57.51099999999999 L 70.868 57.51099999999999 C 70.904 57.51099999999999 70.923 57.52899999999999 70.94099999999999 57.56499999999999 C 70.94099999999999 57.60199999999999 70.94099999999999 57.63799999999999 70.90399999999998 57.65599999999999 L 60.448999999999984 63.60199999999999 C 60.431 63.62 60.411 63.62 60.394 63.62 M 60.03 57.674 L 60.448 58.256 C 60.466 58.275 60.466 58.292 60.466 58.292 L 60.466 63.42 L 70.559 57.674 L 60.03 57.674 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36.06 56.3)",
    id: "yObaPED0TdkmLBYAqUwv9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2.86, -1.51)",
    d: "M 0 3.019 L 0 0 L 5.728 0 L 5.728 3.019 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36.06 56.3)",
    id: "0zN3JBHZeOZiXTnIMjy4H"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-58.2, -75.73)",
    d: "M 61.065 77.403 L 55.337999999999994 77.403 C 55.245999999999995 77.403 55.17399999999999 77.331 55.17399999999999 77.239 L 55.17399999999999 74.22 C 55.17399999999999 74.129 55.245999999999995 74.057 55.337999999999994 74.057 L 61.065 74.057 C 61.157 74.057 61.229 74.129 61.229 74.22 L 61.229 77.239 C 61.248 77.331 61.157 77.403 61.065 77.403 M 55.502 77.058 L 60.902 77.058 L 60.902 74.385 L 55.502 74.385 L 55.502 77.058 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.52 56.3)",
    id: "Uj2DSY4fMQ5e_3or5K-vu"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2.86, -1.51)",
    d: "M 0 3.019 L 0 0 L 5.728 0 L 5.728 3.019 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.52 56.3)",
    id: "0Fb2Fy8OmYtHG4G97RlzZ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-40.66, -75.73)",
    d: "M 43.519 77.403 L 37.791 77.403 C 37.699999999999996 77.403 37.628 77.331 37.628 77.239 L 37.628 74.22 C 37.628 74.129 37.7 74.057 37.791 74.057 L 43.519 74.057 C 43.61 74.057 43.683 74.129 43.683 74.22 L 43.683 77.239 C 43.683 77.331 43.609 77.403 43.519 77.403 M 37.955 77.058 L 43.355 77.058 L 43.355 74.385 L 37.955 74.385 L 37.955 77.058 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.52 38.09)",
    id: "yB_1Vj-jheinw-g7AiGRf"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-54.66, -57.52)",
    d: "M 70.849 57.602 L 70.467 57.07299999999999 L 59.503 57.07299999999999 L 59.248 56.72899999999999 L 39.608999999999995 56.72899999999999 L 38.46399999999999 58.31099999999999 L 60.39399999999999 58.31099999999999 L 59.88499999999999 57.60199999999999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.5 38.08)",
    id: "gMqTizIU07FBKxZSXIrA9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-54.64, -57.51)",
    d: "M 60.394 58.474 L 38.464 58.474 C 38.409 58.474 38.336999999999996 58.437999999999995 38.318 58.382999999999996 C 38.282 58.32899999999999 38.3 58.25599999999999 38.336999999999996 58.20099999999999 L 39.483 56.61899999999999 C 39.519 56.58299999999999 39.555 56.54599999999999 39.61 56.54599999999999 L 59.248000000000005 56.54599999999999 C 59.304 56.54599999999999 59.357000000000006 56.56499999999999 59.376000000000005 56.61899999999999 L 59.575 56.90999999999999 L 70.45 56.90999999999999 C 70.50500000000001 56.90999999999999 70.558 56.92899999999999 70.577 56.98299999999999 L 70.959 57.50899999999999 C 70.99600000000001 57.56399999999999 70.99600000000001 57.63699999999999 70.97800000000001 57.69199999999999 C 70.94200000000001 57.74699999999999 70.88600000000001 57.782999999999994 70.83200000000001 57.782999999999994 L 60.193 57.782999999999994 L 60.503 58.218999999999994 C 60.538 58.27499999999999 60.538 58.346999999999994 60.521 58.401999999999994 C 60.521 58.438 60.467 58.474 60.394 58.474 M 38.791 58.129 L 60.083999999999996 58.129 L 59.775 57.692 C 59.738 57.637 59.738 57.564 59.756 57.509 C 59.792 57.454 59.847 57.419 59.902 57.419 L 70.521 57.419 L 70.375 57.218999999999994 L 59.503 57.218999999999994 C 59.448 57.218999999999994 59.394 57.199999999999996 59.375 57.145999999999994 L 59.175 56.855 L 39.683 56.855 L 38.791 58.129 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.29 46.84)",
    id: "cpj-fnhTUn4kowgetCddp"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,207,12)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.43, -66.27)",
    d: "M 38.464 58.311 L 38.464 63.566 C 42.245999999999995 64.42 45.338 64.62100000000001 45.338 67.039 C 45.338 70.785 40.592 74.22200000000001 37.791000000000004 74.22200000000001 L 43.52 74.22200000000001 C 44.356 73.38600000000001 47.374 69.40400000000001 49.429 69.40400000000001 C 51.484 69.40400000000001 54.502 73.38600000000001 55.338 74.22200000000001 L 61.067 74.22200000000001 C 58.266 74.22200000000001 53.52 70.78500000000001 53.52 67.03900000000002 C 53.52 64.60200000000002 56.612 64.42100000000002 60.394000000000005 63.56600000000002 L 60.394000000000005 58.311000000000014 L 38.464 58.311000000000014 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.3 46.83)",
    id: "j_LOcizJmQ9VEcnYMY5zG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,138,42)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.44, -66.26)",
    d: "M 61.066 74.385 L 55.337 74.385 C 55.301 74.385 55.247 74.366 55.21 74.33 C 55.046 74.166 54.828 73.91199999999999 54.537 73.585 C 53.302 72.18499999999999 51.01 69.56599999999999 49.409 69.56599999999999 C 47.809 69.56599999999999 45.518 72.18399999999998 44.281 73.585 C 43.99 73.91199999999999 43.772 74.166 43.609 74.33 C 43.572 74.366 43.536 74.385 43.481 74.385 L 37.79 74.385 C 37.699 74.385 37.627 74.313 37.627 74.221 C 37.627 74.13000000000001 37.699000000000005 74.058 37.79 74.058 C 40.572 74.058 45.172 70.658 45.172 67.03800000000001 C 45.172 65.111 43.064 64.67500000000001 40.117999999999995 64.07400000000001 C 39.571999999999996 63.966000000000015 39.00899999999999 63.838000000000015 38.42699999999999 63.71100000000001 C 38.35399999999999 63.692000000000014 38.29999999999999 63.62000000000001 38.29999999999999 63.54700000000001 L 38.29999999999999 58.29200000000001 C 38.29999999999999 58.20100000000001 38.37199999999999 58.12900000000001 38.46299999999999 58.12900000000001 L 60.41099999999999 58.12900000000001 C 60.50099999999999 58.12900000000001 60.573999999999984 58.201000000000015 60.573999999999984 58.29200000000001 L 60.573999999999984 63.54700000000001 C 60.573999999999984 63.62000000000001 60.518999999999984 63.69300000000001 60.44699999999998 63.71100000000001 C 59.86499999999998 63.838000000000015 59.30099999999998 63.966000000000015 58.75599999999998 64.07400000000001 C 55.82799999999998 64.67500000000001 53.70099999999998 65.11100000000002 53.70099999999998 67.03800000000001 C 53.70099999999998 70.65700000000001 58.30099999999998 74.058 61.08299999999998 74.058 C 61.17399999999998 74.058 61.24699999999998 74.13000000000001 61.24699999999998 74.221 C 61.248 74.312 61.157 74.385 61.066 74.385 M 55.411 74.058 L 59.339 74.058 C 56.574999999999996 73.09400000000001 53.357 70.149 53.357 67.03800000000001 C 53.357 64.83800000000001 55.703 64.36500000000001 58.667 63.747000000000014 C 59.176 63.63800000000001 59.686 63.52900000000001 60.231 63.420000000000016 L 60.231 58.47400000000002 L 38.628 58.47400000000002 L 38.628 63.420000000000016 C 39.173 63.54700000000002 39.682 63.65600000000001 40.191 63.747000000000014 C 43.155 64.36500000000001 45.501000000000005 64.83800000000001 45.501000000000005 67.03800000000001 C 45.501000000000005 70.13000000000001 42.282000000000004 73.07500000000002 39.519000000000005 74.058 L 43.447 74.058 C 43.593 73.912 43.793 73.676 44.047000000000004 73.385 C 45.32000000000001 71.93 47.666000000000004 69.239 49.43000000000001 69.239 C 51.17600000000001 69.239 53.53900000000001 71.929 54.81300000000001 73.385 C 55.065 73.657 55.266 73.895 55.411 74.058",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArlLogo);
export default __webpack_public_path__ + "static/media/arl_logo.567395ec605e08de5ed26273a12f6934.svg";
export { ForwardRef as ReactComponent };